import {useEffect, useRef} from 'react';

import {useFluxStore} from 'client/framework';
import masqueradeStore from 'client/generic/Masquerade/Masquerade.store';

/**
 * Mandark caches a failed interest forever, so one blip would hide a gated column (LMS/Google
 * Classroom sync) all session. Re-dirty an errored interest once per query (capped — a second
 * failure just keeps it hidden).
 */
export const useRetryErroredInterestOnce = (
  query: {isResourceValid: () => boolean; invalidateInterest: () => void} | null
) => {
  const retriedRef = useRef(false);
  useEffect(() => {
    retriedRef.current = false;
  }, [query]);
  // Bridged (re-runs on state-tree emits) so a fetch that errors after mount re-runs this read —
  // a bare render read would be frozen by the React Compiler and the retry would never fire.
  const isInvalid = useFluxStore(masqueradeStore, () => Boolean(query && !query.isResourceValid()));
  /* eslint-disable react-you-might-not-need-an-effect/no-event-handler -- reacts to derived cache state (an errored interest), not a user event */
  useEffect(() => {
    if (isInvalid && query && !retriedRef.current) {
      retriedRef.current = true;
      query.invalidateInterest();
    }
  }, [isInvalid, query]);
  /* eslint-enable react-you-might-not-need-an-effect/no-event-handler */
};
